import React from 'react';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { store } from '../../utils/types';
import SizeAwareGraph from './SizeAwareGraph';

type Props = {
  doQueryStatus: string;
  doQueryPayload: any;
  visualize: boolean;
  graphWrapperRef: any;
};

const QueryResultArea = ({
  doQueryStatus,
  doQueryPayload,
  visualize,
  graphWrapperRef,
}: Props) => {
  return (
    <>
      {doQueryStatus === 'success' ? (
        <div className="w-full">
          <div className="h-full w-full bg-gray-50">
            <SizeAwareGraph
              visualize={visualize}
              graphWrapperRef={graphWrapperRef}
            />
          </div>
        </div>
      ) : doQueryStatus === 'loading' ? (
        <div className="justify-center items-center w-full h-full">
          <Spin size="large" />
        </div>
      ) : (
        doQueryStatus === 'fail' && (
          <div className="w-full mt-10 justify-center items-center text-white">
            <p>Error occured: {doQueryPayload}</p>
          </div>
        )
      )}
    </>
  );
};

const mapStateToProps = (state: store) => ({
  doQueryStatus: state.query.doQueryOp.status,
  doQueryPayload: state.query.doQueryOp.payload,
  visualize: state.query.requestedQueryDetails?.visualize,
});

export default connect(mapStateToProps)(QueryResultArea);
